// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dspLD","footer":"styles_footer__1JBj_","passCodeTooltip":"styles_passCodeTooltip__2YLA-"};